"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const b_1 = __importDefault(require("b_"));
const video_status_bar_styles_1 = __importDefault(require("./video-status-bar.styles"));
// import { ClickData } from './question-video';
const bar = b_1.default.with('video-status-bar');
/* interface VideoStatusBarProps {
    duration: number;
    clicks: ClickData[];
    titleTpl?: string;
    currentTime?: number;
} */
function VideoStatusBar({ currentTime = 0, duration, clicks, titleTpl = '' }) {
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: bar() }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: video_status_bar_styles_1.default }), (0, jsx_runtime_1.jsx)("div", { className: bar('position-indicator'), style: { width: `${currentTime / duration * 100}%` } }), clicks.map(({ downTime, upTime, timestamp }) => {
                const barTitle = titleTpl
                    .replace('%1', String(Math.round(downTime)))
                    .replace('%2', String(Math.round(upTime)));
                return ((0, jsx_runtime_1.jsx)("div", { title: barTitle, className: bar('item'), style: {
                        left: `${downTime / duration * 100}%`,
                        width: `${(upTime - downTime) / duration * 100}%`
                    } }, `${timestamp}-${downTime}-${upTime}`));
            })] })));
}
exports.default = VideoStatusBar;
